module.exports = "./img/bbe9531835e4419501132cded66745e1.jpg";